const RENDER_DELAY = 300;

export default defineNuxtPlugin({
  name: 'scroll',
  dependsOn: ['keycloak'],
  setup() {
    useRouter().options.scrollBehavior = (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition;
      }

      if (to.hash) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({
              el: to.hash,
              behavior: 'smooth',
              top: 0,
            });
          }, RENDER_DELAY);
        });
      }
    };
  },
});
